<template>
  <v-container fluid fill-height class="d-flex justify-center align-center">
    <!-- Row untuk form login -->
    <v-row justify="center" align="center" class="w-100">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-6" elevation="12">
          <!-- Menambahkan logo di atas form login -->
          <v-img
            src="@/assets/logo-oei-fli-fwi.png"
            alt="Logo"
            height="200px"
            class="mb-4"
            contain
          ></v-img>

          <!-- Form validation -->
          <v-form v-model="valid" @submit.prevent="submit">
            <!-- <v-text-field
              v-model="pointToken"
              label="Token Point"
              required
            ></v-text-field> -->

            <v-btn
              :disabled="!valid"
              color="primary"
              class="ma-2"
              block
              @click="submit()"
            >
              Validasi Token
            </v-btn>
          </v-form>

          <!-- Snackbar error message -->
          <v-snackbar
            v-model="snackbar"
            color="error"
            top
            multi-line
            timeout="5000"
          >
            {{ errorMessage }}
            <v-btn color="white" @click="snackbar = false">Close</v-btn>
          </v-snackbar>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import axios from "axios";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    snackbarMessage,
  },
  data() {
    return {
      pointToken: null,
      historyPointId: null,
      errorMessage: "",
      snackbar: false, // Untuk menampilkan snackbar
      valid: false,
    };
  },
  methods: {
    submit() {
      const url = `${process.env.VUE_APP_API_URL}/points/validation`;
      axios
        .post(url, {
          point_token: this.pointToken, // Kirim password baru
          history_point_id: this.historyPointId, // Kirim password baru
        })
        .then((response) => {
          // Ambil pesan dari backend
          const message =
            response.data.message || "Validation token successfully!";

          // Tampilkan snackbar sukses
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
          this.$router.back();
        })
        .catch((error) => {
          console.error("Error during validation:", error);

          let message = "Failed to validation!"; // Pesan default
          if (error.response) {
            // Pesan error dari backend (jika ada)
            message = error.response.data.message || message;
          } else {
            // Pesan error fallback
            message = error.message || message;
          }

          // Tampilkan snackbar dengan status error
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        });
    },
  },
  mounted() {
    this.pointToken = this.$route.params.token;
    this.historyPointId = this.$route.params.id;
  },
};
</script>
